import type { Messages } from "@lingui/core";
import type { SupportedLocale } from "./i18n";

/**
 * The compiled catalog of one locale, without activating it.
 *
 * Its own module so that a test can replace the catalogs without replacing
 * i18n.ts, whose locale choice is module state its own tests reset
 * (src/test/setup.ts mocks this module; the .po files are compiled by the Lingui
 * Vite plugin, which the test config does not load). Used by `loadCatalog` and
 * by the low-code Studio, which seeds a new item's label in every app language
 * at once (src/lowcode/seedLabels.ts). The bundler caches the import, so the
 * active locale's catalog is not fetched twice.
 */
export async function loadMessages(locale: SupportedLocale): Promise<Messages> {
  const { messages } = await import(`./locales/${locale}/messages.po`);
  return messages as Messages;
}
